/**
 * Payment status values
 */
export enum PaymentStatusEnum {
	/**
	 * Payment is pending
	 */
	PENDING = 'pending',

	/**
	 * Payment is being processed by the payment provider
	 */
	PROCESSING = 'processing',

	/**
	 * Payment has been completed successfully
	 */
	COMPLETED = 'completed',

	/**
	 * Payment has been cancelled by the user
	 */
	CANCELLED = 'cancelled',

	/**
	 * Payment is being retried after a failure
	 */
	RETRYING = 'retrying',

	/**
	 * Payment has failed after multiple retries
	 */
	FAILED = 'failed',

	/**
	 * Payment has expired
	 */
	EXPIRED = 'expired',

	/**
	 * Payment has been refunded.
	 */
	REFUNDED = 'refunded',
}
